<script setup lang="ts">
import { ElDialog } from "element-plus";

/**
 * Aide sur les légendes, catalogues et notes, ouverte par le « ? » au bout des
 * onglets de catalogue.
 */
const visible = defineModel<boolean>({ required: true });
</script>

<template>
  <ElDialog
    v-model="visible"
    :title="$t('canvas:draggable.help.title')"
    append-to-body
    class="catalogue-help-dialog"
    width="min(760px, 95vw)"
    top="8vh"
  >
    <div class="help-body" v-html="$t('canvas:draggable.help.text')" />
  </ElDialog>
</template>

<!-- Non-scoped: reaches the teleported dialog element -->
<style lang="scss">
.el-dialog.catalogue-help-dialog {
  background-color: var(--canvas-bg);
  border: 1px solid var(--canvas-border);
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);

  .el-dialog__header {
    background-color: var(--canvas-bg);
    border-bottom: 1px solid var(--canvas-border);
    padding: 14px 20px;
    margin-right: 0;
  }

  .el-dialog__title {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    font-weight: 600;
  }

  .el-dialog__body {
    background-color: var(--canvas-bg);
    color: rgba(255, 255, 255, 0.85);
    max-height: calc(85dvh - 100px);
    overflow-y: auto;
    padding: 20px;
  }

  .el-dialog__headerbtn .el-icon {
    color: rgba(255, 255, 255, 0.5);

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
</style>

<style lang="scss" scoped>
.help-body {
  font-size: 0.85rem;
  line-height: 1.6;

  :deep(h4) {
    margin: 20px 0 8px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--bs-primary);

    &:first-child {
      margin-top: 0;
    }
  }

  :deep(p) {
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(ul) {
    margin: 0 0 12px;
    padding-left: 20px;
  }

  :deep(li) {
    margin-bottom: 3px;
  }

  :deep(b) {
    color: #fff;
  }

  :deep(a) {
    color: var(--bs-primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .help-link {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid var(--canvas-border);
    font-size: 0.8rem;
  }
}
</style>
